import './style.scss'

import React, { Component } from 'react'

import CartItem from 'components/Cart/CartItem'
import CartItemMobile from 'components/Cart/CartItemMobile'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

export class CartContent extends Component {
    render() {
        const { products, deadline, view, isMobile, isCheckout, deliveryDate, t } = this.props
        if (products.length < 1) {
            return (
                <div className="cart-content cart-content--empty">{t('cartCartContentEmpty')}</div>
            )
        }
        return (
            <div className="cart-content">
                {products.map((item, idx) => {
                    if (isMobile && !isCheckout) {
                        return (
                            <CartItemMobile
                                key={idx}
                                item={item}
                                deadline={deadline}
                                deliveryDate={deliveryDate}
                                quantity={item.quantity}
                                quantityPossible={item.quantityPossible}
                            />
                        )
                    }
                    return (
                        <CartItem
                            key={idx}
                            item={item}
                            deadline={deadline}
                            deliveryDate={deliveryDate}
                            quantity={item.quantity}
                            quantityPossible={item.quantityPossible}
                            view={view}
                        />
                    )
                })}
            </div>
        )
    }
}

CartContent.propTypes = {
    products: PropTypes.array,
    deadline: PropTypes.object,
    deliveryDate: PropTypes.string,
    isMobile: PropTypes.bool,
    view: PropTypes.string,
    isCheckout: PropTypes.bool,
    t: PropTypes.func,
}

export const mapStateToProps = ({ cart, ui, router, distribution, checkout }) => {
    return {
        deliveryDate: checkout.deliveryDate,
        products: cart.products,
        deadline: distribution.deadline,
        isMobile: ui.isMobile,
        isCheckout: new RegExp(/^\/checkout/).test(router.location.pathname),
    }
}

export default connect(mapStateToProps)(withTranslation()(CartContent))
